import React from "react";
import { InputNumber, InputNumberProps } from "antd";

interface CustomInputNumberProps extends InputNumberProps {
  isNotSettingMenu?: boolean;
}

const CustomInputNumber: React.FC<CustomInputNumberProps> = (props) => {
  const { isNotSettingMenu } = props;

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const char = String.fromCharCode(e.which);
    if (!/[0-9.]/.test(char)) {
      e.preventDefault();
    }
  };

  // const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
  //   const pasteData = e.clipboardData.getData("Text");
  //   if (!/^[0-9.]+$/.test(pasteData)) {
  //     e.preventDefault();
  //   }
  // };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasteData = e.clipboardData.getData("Text");
    // Remove commas and validate if the result is a valid number
    const sanitizedData = pasteData.replace(/,/g, "");
    if (isNaN(Number(sanitizedData))) {
      e.preventDefault();
    }
  };

  if (isNotSettingMenu && isNotSettingMenu === true)
    return <InputNumber className="w-full" onKeyPress={handleKeyPress} onPaste={handlePaste} min={0} {...props} />;
  else return <InputNumber className="w-full" precision={10} onKeyPress={handleKeyPress} onPaste={handlePaste} min={0} {...props} />;
};

export default CustomInputNumber;
